import { getWebInstrumentations, initializeFaro, NavigationInstrumentation, UserActionInstrumentation, type Faro } from "@grafana/faro-web-sdk";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  if (!config.public.grafanaFaroUrl) {
    return {
      provide: {
        faro: {
          api: {
            startUserAction: () => undefined,
          },
        },
      },
    }
  }
  try {
    const instrumentation = [
      ...getWebInstrumentations(),
      // new TracingInstrumentation(),
      new UserActionInstrumentation(),
      new NavigationInstrumentation()
    ];
    const faro: Faro = initializeFaro({
      url: config.public.grafanaFaroUrl,
      instrumentations: instrumentation,
      app: {
        name: config.public.grafanaAppName,
        version: config.public.appVersion,
        environment: config.public.appEnvironment,
      },
      experimental: {
        trackNavigation: true,
      },
    });
    return {
      provide: {
        faro: faro
      }
    }
  } catch (error) {
    console.error("Failed to initialize Faro:", error);
    throw error;
  }
});
